import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import { parse } from '@fortawesome/fontawesome-svg-core';


export const AgregarFecha = props => {

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [activate, setActivate] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtFecha = useRef();

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    useEffect(() => {
    }, []);


    const blanquear = () => {

        setActivate(false);

    }


    const cancelar = () => {
        blanquear();
        props.onHideCancelar();
    }

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtFecha.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'La fecha no debe estar vacia.', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        }

        if (sigue) {

            setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El Registro va a ser Modificado.', icono: 'exito' });

        }


    };


    const cerrarModal = () => {
        props.onHideAceptar(txtFecha.current.value);
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtFecha.current.value = moment.utc(props.fecha).format('YYYY-MM-DD')

            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>Fecha del Sistema</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                {/*  <MensajeCapcha
                    show={mostrar4}
                    onHideAcepta={validarCapcha} onHideCancela={handleCancelaCapcha} /> */}
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div style={{ height: "auto", overflow: "auto" }}>
                    <div className="border-azul rounded">
                        <div className="col-md-12 row px-0 mx-auto">

                            <div className="col-md-12 mx-auto mb-2 mt-2">
                                <label htmlFor="validationTooltipUsername">Fecha del Sistema: </label>
                                <input type="date" autocomplete="off" ref={txtFecha} className="form-control form-control-lg" id="inputLogin" />
                            </div>



                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="col-md-12 mx-auto row">
                    <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-success col-md-6 btn-sm rounded-pill"><i className="fas fa-check-circle">  Aceptar</i></button>
                    <button ref={btnCancela} onClick={cancelar} className="btn btn-danger col-md-6 btn-sm rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
                </div>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal():
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>
    );
}

//export default CambiarClave;